

module.exports = (hsl) => {
  let finalStep = (hue, step1, step2) => 6 * hue < 1 ? step2 + 6 * hue * (step1 - step2) : 2 * hue < 1 ? step1 : 3 * hue < 2 ? step2 + 6 * (2 / 3 - hue) * (step1 - step2) : step2;
  if (!hsl.sat) {
    let shade = hsl.lum * 255;
    return {
      'red': ~~shade,
      'green': ~~shade,
      'blue': ~~shade
    };
  } else {
    let step1 = hsl.lum < 0.5 ? hsl.lum * (1 + hsl.sat) : hsl.lum + hsl.sat - (hsl.lum * hsl.sat);
    let step2 = (2 * hsl.lum) - step1;
    let hue = hsl.hue / 360;
    return {
      'red': ~~(255 * finalStep(hue > 2 / 3 ? hue - 2 / 3 : hue + 1 / 3, step1, step2)),
      'green': ~~(255 * finalStep(hue, step1, step2)),
      'blue': ~~(255 * finalStep(hue < 1 / 3 ? hue + 2 / 3 : hue - 1 / 3, step1, step2))
    };
  }
};


// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hsl/toRgb.js